import React from "react";
import { Link } from "react-router-dom";
import { topNavStyle } from "./nav/topNavStyle";
import ProfileDropdown from "./ProfileDropdown";
import BrandWordmark from "./BrandWordmark";

function PageShell({ children, maxWidth = 600 }) {
  return (
    // theme-auto opts the page into dark mode; BrandWordmark picks the cut that
    // reads on the current theme. Create and Join League use this shell.
    <div className="theme-auto" style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg-page)', paddingBottom: 80 }}>
      <nav style={topNavStyle()}>
        <Link to="/home">
          <BrandWordmark width="clamp(80px, 20vw, 140px)" alt="Lineup" />
        </Link>
        <ProfileDropdown />
      </nav>
      <div style={{ maxWidth, margin: '0 auto', padding: '24px 16px' }}>
        {children}
      </div>
    </div>
  );
}

export default PageShell;
